import axios from "axios";
import { BASE_URL } from "@/env";

export default async function setTokenRelations() {
  let refresh = localStorage.getItem("refreshToken");

  //console.log(refresh);
  ///se toma el token refresh
  const apiClient = axios.create({
    baseURL: BASE_URL,
    withCredentials: false,
  });
  const respuesta = await apiClient.post("/refresh-token-relations", {
    refreshToken: refresh.toString(),
  });
  if (respuesta.status === 200) {
    const newToken = respuesta.data.Token;
    localStorage.setItem("token", newToken);

    return true;
  } else {
    console.log("Error al refrescar token, estado:", respuesta.status);
    return false;
  }
}
